module.exports = __webpack_public_path__ + "img/firefox_step_3.f0447880.jpg";